import Search from "@mui/icons-material/Search";
import { SCHEMA_TYPES } from "helpers/utils/constants";
import {
  EDITOR_VALIDATOR,
  NUMBER_VALIDATOR,
  REQUIRED_VALIDATOR,
  TITLE_VALIDATOR,
} from "helpers/utils/validators";
import { ca, us } from "assets/png/icons/countries/index";

export const APPLICATION_STATUS = (skipAll) =>
  [
    {
      title: "All",
      key: "all",
    },
    {
      title: "No Status",
      key: "no_status",
    },
    {
      title: "Shortlisted",
      key: "shortlisted",
    },
    {
      title: "Interview",
      key: "interview",
    },
    {
      title: "Offer",
      key: "offer",
    },
    {
      title: "Hired",
      key: "hired",
    },
    {
      title: "Rejected",
      key: "rejected",
    },
  ].filter((d) => !skipAll || d?.key !== "all");

export const schema = [
  {
    title: "Job Title",
    name: "title",
    type: SCHEMA_TYPES.INPUT,
    lg: 12,
    validator: TITLE_VALIDATOR,
  },
  {
    title: "Description",
    errorTitle: "Description",
    name: "description",
    type: SCHEMA_TYPES.EDITOR,
    validator: EDITOR_VALIDATOR,
    lg: 12,
  },
  {
    title: "Job Type",
    name: "job_type_id",
    type: SCHEMA_TYPES.MASTER,
    validator: REQUIRED_VALIDATOR,
  },
  {
    title: "Experience Level",
    name: "experience_level_id",
    type: SCHEMA_TYPES.MASTER,
  },
  {
    title: "Number of Openings",
    name: "openings",
    type: SCHEMA_TYPES.INPUT,
    validator: NUMBER_VALIDATOR,
  },
  {
    title: "Hours Per Week",
    name: "hours",
    type: SCHEMA_TYPES.INPUT,
    validator: NUMBER_VALIDATOR,
  },
  {
    title: "Compensation Type",
    name: "compensation_type_id",
    type: SCHEMA_TYPES.MASTER,
  },
  {
    title: "Compensation",
    name: "compensation",
    type: SCHEMA_TYPES.COMPOSITE_INPUT,
    validator: REQUIRED_VALIDATOR,
    options: [
      {
        key: "CAD",
        value: "CAD",
        icon: ca,
      },
      {
        key: "USD",
        value: "USD",
        icon: us,
      },
    ],
    optionName: "compensation_country_type",
  },
  {
    title: "Payment Frequency",
    name: "payment_frequency",
    type: SCHEMA_TYPES.SELECT,
    options: [
      { value: "Hourly", key: "hourly" },
      { value: "Daily", key: "daily" },
      { value: "Weekly", key: "weekly" },
      { value: "Monthly", key: "monthly" },
    ],
    validator: REQUIRED_VALIDATOR,
  },
  {
    title: "Application Deadline",
    name: "application_deadline",
    type: SCHEMA_TYPES.DATE,
    validator: REQUIRED_VALIDATOR,
    disablePast: true,
  },
  {
    title: "Job Status",
    name: "status",
    type: SCHEMA_TYPES.SELECT,
    validator: REQUIRED_VALIDATOR,
    options: [
      {
        key: "open",
        value: "Open",
      },
      {
        key: "closed",
        value: "Closed",
      },
      {
        key: "draft",
        value: "Draft",
      },
    ],
  },
  {
    title: "Skills",
    name: "skills",
    multi: true,
    type: SCHEMA_TYPES.MASTER,
  },
  {
    title: "Address",
    name: "address",
    placeholder: "Search",
    inputProps: {
      icon: <Search />,
      iconLeft: true,
    },
    type: SCHEMA_TYPES.GOOGLE_PLACES,
    validator: REQUIRED_VALIDATOR,
  },
  {
    title: "Work Mode",
    name: "work_mode",
    type: SCHEMA_TYPES.SELECT,
    options: [
      {
        key: "onsite",
        value: "On-Site",
      },
      {
        key: "hybrid",
        value: "Hybrid",
      },
      {
        key: "remote",
        value: "Remote",
      },
    ],
  },
];

export const DATE_POSTED = [
  {
    value: "Any time",
    key: "anytime",
  },
  {
    value: "Past 24 hours",
    key: "day",
  },
  {
    value: "Past week",
    key: "week",
  },
  {
    value: "Past month",
    key: "month",
  },
];

export const WORK_MODE = [
  {
    key: "onsite",
    value: "On-site",
  },
  {
    key: "hybrid",
    value: "Hybrid",
  },
  {
    key: "remote",
    value: "Remote",
  },
];

export const JOB_STATUS = [
  {
    title: "Open",
    key: "open",
  },
  {
    title: "Closed",
    key: "closed",
  },
  {
    title: "Draft",
    key: "draft",
  },
];
